import dataRaw from './data_live/attacks.csv'
import updateString from './data_live/update.txt'
//import dataAidRaw from './data_live/aid.json'
//import dataAidTotalRaw from './data_live/aid_total.json'
import dataAidRaw from './data_frozen/aid_rel22.json'
import dataAidTotalRaw from './data_frozen/aid_total_rel22.json'
import dataAidRawAug from './data_frozen/aid_aug.json'
import dataAidTotalRawAug from './data_frozen/aid_total_aug.json'
import dataAidRawOct from './data_frozen/aid_oct.json'
import dataAidTotalRawOct from './data_frozen/aid_total_oct.json'

/// Import data from 15th release (15.01.2024)
import dataAid15Raw from './data_frozen/aid_2024-01-15.json'
import dataAidTotal15Raw from './data_frozen/aid_total_2024-01-15.json'

import { stringToDate } from './utils'

dataRaw.forEach((d) => {
	d.start_date = stringToDate(d.start_date, 'yyyy-mm-dd', '-')
	d.end_date = stringToDate(d.end_date, 'yyyy-mm-dd', '-')
	d.attacks = +d.attacks
	d.battles = +d.battles
	d.airstrikes_shelling_artillery_russia =
		+d.airstrikes_shelling_artillery_russia
	d.airstrikes_shelling_artillery_ukraine =
		+d.airstrikes_shelling_artillery_ukraine
})

export const dataAttacks = dataRaw

export const updateDateAttacks = stringToDate(updateString, 'yyyy-mm-dd', '-')

export const lastDateAttacks = dataAttacks.at(-1).end_date

// TODO: FIXME upstream in Data Export
dataAidRaw.forEach((d) => {
	d.name = d.name
		.replace('Tschechische Republik', 'Tschechien')
		.replace('Vereinigtes Königreich', 'UK')
	if (!d.total_abs) {
		d.total_abs = d.eu_abs + d.bilat_abs
		d.total_gdp = d.eu_gdp + d.bilat_gdp
		d.total_pop = d.eu_pop + d.bilat_pop
	}
})

export const dataAid = dataAidRaw
export const dataAidTotal = dataAidTotalRaw

export const dataAid15 = dataAid15Raw
export const dataAidTotal15 = dataAidTotal15Raw

export const dataAidAug = dataAidRawAug
export const dataAidTotalAug = dataAidTotalRawAug

export const dataAidOct = dataAidRawOct
export const dataAidTotalOct = dataAidTotalRawOct
